import {cs} from "@Common/react/chain-services";
import {ui} from "@Common/ui-components/heavy/item-options/modules/expo-types/expo-types";

import {summaryLines} from "../common/summary-lines-expo";

import {PaperType} from "./ui/paper-type";

export const paperTypeModules = ({agent}) => [
    {
        load: ({paperType2, method, totalQuantity}, rootNext) => cs(
            ({}) => rootNext((() => {
                if (!paperType2) {
                    return null;
                }
                const {state, paperTypes, paperType, finishing, finishingTypes,} = paperType2;
                const applyPostalProtectBenefit = (
                    finishing?.dev_key.startsWith("laminate")
                    && agent?.activeBenefits?.includes("postalProtect")
                );
                return {
                    summaryLines: finishing && (
                        finishing.id === "3" ? [
                            {
                                label: finishing.subGroup + " Side 1",
                                unitPrice: +finishing.side1Price * (applyPostalProtectBenefit ? 0.5 : 1),
                                qty: totalQuantity,
                            },
                            {
                                label: finishing.subGroup + " Side 2",
                                unitPrice: +finishing.side2Price * (applyPostalProtectBenefit ? 0.5 : 1),
                                qty: totalQuantity,
                            }
                        ] : [
                            {
                                label: finishing.subGroup + " " + finishing.name,
                                unitPrice: +finishing.unitPrice * (applyPostalProtectBenefit ? 0.5 : 1),
                                qty: totalQuantity,
                            }
                        ]
                    ),

                    ui: method === "download" ? null : PaperType({
                        state,
                        paperTypes, paperType, finishing, finishingTypes,
                        totalQuantity,

                        // errorMessage,
                        // paperTypeEh, paperTypeErrDomRef,
                    }),
                };
            })()),
        ),
        requires: ["paperType2", "method", "totalQuantity"],
        expo: [summaryLines, ui("paperType")],
    },
];
